<header class="painel-header">
  <div class="painel-header--logo">
    <a [routerLink]="['/']"><img src="/assets/images/logowhite-upgrade.svg"></a>
  </div>
  <div class="painel-header--navigation">
    <ul>
      <li>
        <div class="nav-item-language">
          <button class="language-box">
            <span (click)="changeLanguage(i, lang.flag)" *ngFor="let lang of languages; let i = index"
                  ngClass="flag-icon flag-icon-{{ lang.flag }}"></span>
            <!-- <span [translate]="'navigation/change'">Change</span> -->
          </button>
        </div>
      </li>
      <li><a [routerLink]="['/painel/configuration']"><i class="material-icons">person</i></a></li>
      <li><a (click)="logoutUser()" href=""><i class="material-icons">exit_to_app</i></a></li>
    </ul>
  </div>
</header>
